import { RelatedList, col } from "@/components/Record";
import { formatINR, formatDateTime } from "@/lib/format";
import { Card } from "@/components/Shared";
import { imgSrc } from "@/lib/api";

export const LINE_COLS = (showTracking) => [
  { key: "code", label: "Product", render: (l) => <div className="flex items-center gap-2">{imgSrc(l.image_url) && <img src={imgSrc(l.image_url)} alt="" className="w-9 h-9 rounded-md object-contain border border-[#E6E8F0] bg-white shrink-0" data-testid={`line-img-${l.code}`} />}<div><div className="font-medium text-[#101D51]">{l.name}</div><div className="text-[11px] text-[#6B7189]">{l.code} · HSN {l.hsn}</div></div></div> },
  { key: "quantity", label: "Qty", right: true, render: (l) => `${l.quantity} ${l.unit}` },
  ...(showTracking ? [{ key: "invoiced_qty", label: "Invoiced", right: true, render: (l) => l.invoiced_qty || 0 }] : []),
  col.money("unit_price", "Rate"),
  { key: "discount_pct", label: "Disc", right: true, render: (l) => (l.discount_pct ? `${(l.discount_pct * 100).toFixed(1)}%` : "—") },
  col.money("net", "Taxable"),
  { key: "gst_rate", label: "GST", right: true, render: (l) => `${Math.round(l.gst_rate * 100)}%` },
  col.money("total", "Total"),
];

export function LinesRelated({ title, lines, showTracking }) {
  return <RelatedList kind="line" title={title} rows={lines} columns={LINE_COLS(showTracking)} testid="doc-lines" />;
}

export function TotalsPanel({ d, extra }) {
  const Row = ({ l, v, bold, testid, cls = "" }) => (
    <div className={`flex justify-between py-1 ${bold ? "font-bold text-lg border-t border-[#101D51] mt-1 pt-2" : "text-sm"} ${cls}`}><span>{l}</span><span data-testid={testid}>{v}</span></div>);
  return (
    <Card className="p-4 text-[#101D51]" data-testid="totals-panel">
      <div className="text-xs font-semibold uppercase tracking-wide text-[#6B7189] mb-1">Totals · {d.is_intra_state ? "CGST + SGST" : "IGST"}</div>
      <Row l="Subtotal" v={formatINR(d.subtotal)} />
      {d.discount_total > 0 && <Row l="Discount" v={`- ${formatINR(d.discount_total)}`} />}
      <Row l="Taxable value" v={formatINR(d.taxable_total)} />
      {d.cost_total != null && d.cost_total > 0 && <Row l="Margin" v={`${formatINR(d.margin_total)} (${((d.margin_pct || 0) * 100).toFixed(1)}%)`} cls={d.margin_total < 0 ? "text-[#F83A84]" : "text-[#0B7C5A]"} testid="totals-margin" />}
      {d.is_intra_state ? <><Row l="CGST" v={formatINR(d.cgst_total)} /><Row l="SGST" v={formatINR(d.sgst_total)} /></> : <Row l="IGST" v={formatINR(d.igst_total)} />}
      <Row l="Grand total" v={formatINR(d.grand_total)} bold testid="doc-grand-total" />
      {extra}
    </Card>
  );
}

export function HistoryPanel({ history }) {
  return (
    <Card className="p-4">
      <div className="text-xs font-semibold uppercase tracking-wide text-[#6B7189] mb-3">Status history</div>
      <ol className="relative border-l border-[#E6E8F0] ml-2 space-y-3" data-testid="doc-timeline">
        {[...(history || [])].reverse().map((h) => (
          <li key={`${h.at}-${h.status}`} className="ml-4"><span className="absolute -left-1.5 w-3 h-3 rounded-full bg-[#101D51] border-2 border-white" />
            <div className="text-sm font-medium text-[#101D51]">{h.status}{h.note ? <span className="text-[#6B7189] font-normal"> — {h.note}</span> : ""}</div>
            <div className="text-[11px] text-[#6B7189]">{formatDateTime(h.at)}</div></li>))}
      </ol>
    </Card>
  );
}
